module.exports = __webpack_public_path__ + "img/deviations.74da980c.svg";